import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotAuthGuard } from '@cutting/main/shared/guards/not-auth.guard';

import { ActivateAccountBySmsCodeComponent } from './activate-account-by-sms-code.component';

const routes: Routes = [
  {
    path: 'client/auth/activate-account-by-sms-code',
    component: ActivateAccountBySmsCodeComponent,
    canActivate: [NotAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [NotAuthGuard],
})
export class ActivateAccountBySmsCodeRoutingModule {}
